// Общий транспорт для авторизации и админки: одинаковая обработка кодов
// ошибок и одинаковое поведение при недоступной сети.

/** Код ошибки с сервера + подробности; тексты подставляет интерфейс. */
export interface ApiError {
  error: string;
  problems?: string[];
  retryAfter?: number;
  /** Человекочитаемое сообщение от провайдера (например, от ИИ-провайдера) — не все
   *  коды его несут, но там, где несут (recog.err.provider), интерфейсу
   *  нужно его показать, а не только код ошибки. */
  message?: string;
}

export type ApiResult<T> = { ok: true; value: T } | { ok: false; error: ApiError };

export async function request<T>(
  path: string,
  init: RequestInit & { json?: unknown } = {},
): Promise<ApiResult<T>> {
  const { json, ...rest } = init;
  try {
    const res = await fetch(path, {
      ...rest,
      headers: {
        accept: 'application/json',
        ...(json === undefined ? {} : { 'content-type': 'application/json' }),
        ...rest.headers,
      },
      body: json === undefined ? rest.body : JSON.stringify(json),
    });

    if (res.status === 204) return { ok: true, value: undefined as T };

    const body = (await res.json().catch(() => null)) as (T & ApiError) | null;
    if (res.ok) return { ok: true, value: (body ?? undefined) as T };
    return {
      ok: false,
      error: {
        error: body?.error ?? `http_${res.status}`,
        problems: body?.problems,
        retryAfter: body?.retryAfter,
        message: body?.message,
      },
    };
  } catch {
    // Сеть недоступна — отличаем от отказа сервера, текст будет другой.
    return { ok: false, error: { error: 'network' } };
  }
}
